import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import createAxiosInstance from '../../services/axiosConfig';

const api = createAxiosInstance(process.env.REACT_APP_ESTEIRA_BACK + '/rest/propostaEsteiraController');
type Sugestao = { proposta: number; fundoAtual: number | null; fundoSugerido: number | null;
  nomeFundo: string | null; valorPrincipal: number; saldo: number | null; pendencia: string; detalhe: string };
const moeda = (v: number | null) => v == null ? '—' : v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export default function ConfirmacaoFidc({ idProposta, onConcluido }: { idProposta: number; onConcluido: () => void }) {
  const [dados, setDados] = useState<Sugestao | null>(null);
  const [justificativa, setJustificativa] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [decisao, setDecisao] = useState<boolean | null>(null);
  const erroTexto = (e: any) => typeof e.response?.data === 'string' ? e.response.data : 'Não foi possível concluir. Atualize a consulta e tente novamente.';
  const carregar = async () => {
    setOcupado(true); setErro(''); setDados(null); setDecisao(null);
    try { setDados((await api.get('/confirmacaoFidc', { params: { idProposta } })).data); }
    catch (e) { setErro(erroTexto(e)); }
    finally { setOcupado(false); }
  };
  useEffect(() => { carregar(); }, [idProposta]); // eslint-disable-line react-hooks/exhaustive-deps
  const salvar = async (confirmar: boolean) => {
    setOcupado(true); setErro('');
    try {
      const resposta = await api.post('/confirmacaoFidc', { idProposta, confirmar, justificativa: justificativa.trim() });
      if (resposta.data.avancou) onConcluido();
      else { await carregar(); setMensagem(confirmar ? 'Aprovação registrada, mas a proposta continua pendente. Consulte o motivo abaixo.' : 'Reprovação registrada. A proposta permanece pendente, sem reserva ou pagamento.'); }
      setDecisao(null);
    } catch (e) { setErro(erroTexto(e)); setDecisao(null); setDados(null); }
    finally { setOcupado(false); }
  };
  return <section className="card mb-3" aria-label="Confirmação FIDC">
    <div className="card-header"><strong>BPO - Confirmação FIDC</strong></div>
    <div className="card-body">
      {erro && <div role="alert" className="alert alert-danger">{erro}</div>}
      {mensagem && <div role="status" className="alert alert-info">{mensagem}</div>}
      <Button variant="outline-primary" disabled={ocupado} onClick={carregar}>Atualizar análise</Button>
      {dados && <>
        <div className="alert alert-warning mt-3">{dados.pendencia}</div>
        <p><strong>Valor principal:</strong> {moeda(dados.valorPrincipal)} · <strong>FIDC atual:</strong> {dados.fundoAtual ?? 'Não selecionado'}</p>
        <p><strong>FIDC selecionado na análise:</strong> {dados.nomeFundo ?? 'Nenhum FIDC selecionado'} · <strong>Saldo disponível:</strong> {moeda(dados.saldo)}</p>
        {dados.detalhe && <p>{dados.detalhe}</p>}
        <p>Ao aprovar, o sistema buscará um fundo elegível para a proposta inteira. Esta confirmação não envia pagamento nem reserva limite; o saldo será validado novamente no pagamento.</p>
      </>}
      <label htmlFor="justificativaConfirmacaoFidc">Justificativa da decisão</label>
      <textarea id="justificativaConfirmacaoFidc" className="form-control mb-3" maxLength={1000}
        value={justificativa} disabled={ocupado} onChange={e => setJustificativa(e.target.value)} />
      <Button variant="success" className="me-2" disabled={ocupado || !dados || !justificativa.trim()} onClick={() => setDecisao(true)}>Aprovar</Button>
      <Button variant="danger" disabled={ocupado || !justificativa.trim()} onClick={() => setDecisao(false)}>Reprovar</Button>
    </div>
    <Modal show={decisao !== null} onHide={() => !ocupado && setDecisao(null)} centered backdrop="static">
      <Modal.Header closeButton={!ocupado}><Modal.Title>Confirmar decisão</Modal.Title></Modal.Header>
      <Modal.Body>{decisao
        ? 'O sistema vai selecionar outro FIDC elegível para distribuir o valor faltante. Tem certeza que deseja continuar?'
        : 'Deseja reprovar a redistribuição e manter a proposta pendente, sem consumir limite?'}
        <p className="mt-2">A proposta não será dividida entre fundos. Sua decisão será registrada nas observações internas do Banco.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={ocupado} onClick={() => decisao ? salvar(false) : setDecisao(null)}>NÃO</Button>
        <Button disabled={ocupado} onClick={() => salvar(decisao === true)}>{ocupado ? 'Registrando...' : 'SIM'}</Button>
      </Modal.Footer>
    </Modal>
  </section>;
}
